module.exports = __webpack_public_path__ + "static/media/app-store-white.283b956f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/app-store-white.svg
 ** module id = 1260
 ** module chunks = 0
 **/